import { render, staticRenderFns } from "./AddSystem.vue?vue&type=template&id=1ad739e4&scoped=true"
import script from "./AddSystem.vue?vue&type=script&lang=js"
export * from "./AddSystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad739e4",
  null
  
)

export default component.exports